var map = {
	"./allinc.png": 5879,
	"./allinclusive.png": 8821,
	"./alpereiser.png": 4720,
	"./amisol.png": 4795,
	"./apollo.png": 9257,
	"./escapeaway.png": 887,
	"./lionalpin.png": 2858,
	"./loveholidays.png": 3915,
	"./nazar.png": 5098,
	"./norwegianholidays.png": 2263,
	"./solfaktor.png": 1311,
	"./solia.png": 9876,
	"./soliadynamic.png": 47,
	"./test.png": 2296,
	"./ticket.png": 5972,
	"./tripx.png": 3847,
	"./tui.png": 4254,
	"./ving.png": 486,
	"./vingdynamic.png": 2061,
	"./vitalreiser.png": 4116
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2596;